// IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): чистая логика клавиш списка автодополнения ячейки грида
// (AttrGrid.dropdown_keydown): Enter коммитит ТОЛЬКО подсвеченный пункт либо точное совпадение набранного текста с названием пункта (все языки: title + titles_alt;
// также code / id), иначе список и ввод остаются открытыми; ↓/↑ двигают подсветку. Выключатель — настройка fe.grid.autocompleteKeys (по умолчанию включено).
export const FLAG_GRID_AUTOCOMPLETE_KEYS = 'fe.grid.autocompleteKeys'

const norm = (v) => String(v ?? '').trim().toLowerCase()

// названия пункта по приоритету: 0 — основное название, 1 — названия на других языках, 2 — code / id
function titleTiers(item) {
    const alt = Array.isArray(item?.titles_alt) ? item.titles_alt.map(norm) : []
    return [[norm(item?.title)], alt, [norm(item?.code), norm(item?.id)]]
}

// Индекс пункта, чьё название точно (без регистра, с обрезкой пробелов) равно тексту; -1 — нет или неоднозначно
// (несколько разных пунктов с одним названием на одном уровне: выбирать нужно подсветкой, а не наугад).
export function exactMatchIndex(items, text) {
    const q = norm(text)
    if (!q || !Array.isArray(items)) return -1
    const tiers = items.map(titleTiers)
    for (let tier = 0; tier < 3; tier++) {
        const hits = []
        tiers.forEach((t, i) => { if (t[tier].includes(q)) hits.push(i) })
        if (!hits.length) continue
        const ids = new Set(hits.map(i => String(items[i]?.id)))
        return ids.size === 1 ? hits[0] : -1
    }
    return -1
}

// Что делает Enter: { index, how: 'highlight' | 'exact' } либо null (не коммитить, оставить ввод и список открытыми).
export function pickOnEnter(items, highlighted, text) {
    if (!Array.isArray(items) || !items.length) return null
    if (Number.isInteger(highlighted) && highlighted >= 0 && highlighted < items.length) return { index: highlighted, how: 'highlight' }
    const i = exactMatchIndex(items, text)
    return i >= 0 ? { index: i, how: 'exact' } : null
}

// Новая позиция подсветки: dir +1 (↓) / -1 (↑); с краёв не заворачивает (как прокрутка списка); из «нет подсветки» ↓ даёт первый пункт, ↑ — тоже первый.
export function moveHighlight(current, count, dir) {
    if (!(count > 0)) return -1
    const cur = Number.isInteger(current) ? current : -1
    if (cur < 0) return 0
    return Math.min(count - 1, Math.max(0, cur + (dir < 0 ? -1 : 1)))
}
